
import { DataService } from './common/data.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, RouterOutlet, Router, ActivatedRoute } from '@angular/router';
import { CounterpartyLimitsComponent } from './DashBoardManagement/counterparty-management/ChildComponents/CounterpartyLimits/CounterpartyLimits.component';
import { PermissionGuard } from './common/permission.guard';


const routes: Routes = [

  //#Route 25a,b
  //Credit Facility Management Lazy Loaded Module START
  {
    path: 'CreditFacilityManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 268 },
    loadChildren: () => import('./CreditFacility/CreditFacility.module').then(m => m.CreditFacilityModule)
  },

  //Route #5
  //Unauthorized Lazy Loaded Module START
  {
    path: 'UnAuthorized/:error',
    loadChildren: () => import('../app/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule)
  },
  //Unauthorized Lazy Loaded Module END

  //Route #2
  ////Limit Management Lazy Loaded Module START
  //{
  //  path: 'LimitManagement',
  //  loadChildren: () => import('./limit-management/limit-management-routing.module').then(m => m.LimitManagementRoutingModule)
  //},
  //Limit Management Lazy Loaded Module END

  //Route #3a,b
  //Credit Application Lazy Loaded Module START
  // {
  //   path: 'CreditApplication',
  //   loadChildren: () => import('./Credit-Application/Credit-Application.module').then(m => m.CreditApplicationModule)
  // },

  // {
  //   path: 'CreditApplication/:lDealEntryId',
  //   loadChildren: () => import('./Credit-Application/Credit-Application.module').then(m => m.CreditApplicationModule)
  // },
  //Credit Application Lazy Loaded Module END


  //Route #4
  //Financials Statements Lazy Loaded Module START
  {
    path: 'FinancialStatements/:ObligorId',
    loadChildren: () => import('./Financial-Statements/Financial-Statements.module').then(m => m.FinancialStatementsModule)
  },
  //Financials Statements Lazy Loaded Module END  



  //Route #6a,b
  //Policy Management Lazy Loaded Module START
  {
    path: 'PolicyManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 350 },
    loadChildren: () => import('./policy-management/policy-management.module').then(m => m.PolicyManagementModule)
  },


  {
    path: 'PolicyManagement/:lPolicyId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 350 },
    loadChildren: () => import('./policy-management/policy-management.module').then(m => m.PolicyManagementModule)
  },
  //Policy Management Lazy Loaded Module END





  //Route #7a,b
  //Policy Customer Limit Assesment Lazy Loaded Module START
  {
    path: 'PolicyCustomerLimitAssesment',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 66 },
    loadChildren: () => import('./policy-customer-limit-assessment/policy-customer-limit-assessment.module').then(m => m.PolicyCustomerLimitAssesmentModule)
  },


  {
    path: 'PolicyCustomerLimitAssesment/:lTradingCounterpartyId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 66 },
    loadChildren: () => import('./policy-customer-limit-assessment/policy-customer-limit-assessment.module').then(m => m.PolicyCustomerLimitAssesmentModule)
  },
  //Policy Customer Limit Assesment Lazy Loaded Module END






  //Route #8a,b
  //Portfolio Parent Lazy Loaded Module(part of cp child components module) START
  {
    path: 'PortFolioLimitManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 130 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/portfoliolimit/portfolio.module').then(m => m.PortfolioParentModule)
  },


  {
    path: 'PortfolioManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 130 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/portfoliolimit/portfolio.module').then(m => m.PortfolioParentModule)
  },

  {
    path: 'DocumentTemplateMangement',
    loadChildren: () => import('./DocumentTemplateMangement/DocumentTemplateMangement.module').then(m => m.DocumentTemplateMangementModule)
  },

  //Portfolio Parent Management Lazy Loaded Module(part of cp child components module) END




  //Route #9a,b,c,d,e
  //Workflow Inbox Lazy Loaded Module START
  {
    path: 'Inbox/:menuId',
    loadChildren: () => import('./WorkflowDashBoard/WorkflowDashBoard.module').then(m => m.WorkflowDashBoardModule)
  },

  {
    path: 'Inbox/:menuId/:UserAction/:BPD/:BPI/:BPS',
    loadChildren: () => import('./WorkflowDashBoard/WorkflowDashBoard.module').then(m => m.WorkflowDashBoardModule)
  },
  {
    path: 'Inbox/:menuId/:UserAction/:BPD/:BPS',
    loadChildren: () => import('./WorkflowDashBoard/WorkflowDashBoard.module').then(m => m.WorkflowDashBoardModule)
  },

  {
    path: 'Inbox/:menuId/:UserAction/:BPD/:BPI/:BPS/:BPRAID/:BPRA',
    loadChildren: () => import('./WorkflowDashBoard/WorkflowDashBoard.module').then(m => m.WorkflowDashBoardModule)
  },

  {
    path: 'Inbox/:menuId/:UserAction/:Name',
    loadChildren: () => import('./WorkflowDashBoard/WorkflowDashBoard.module').then(m => m.WorkflowDashBoardModule)
  },

  {
    path: 'Inbox/:menuId/:UserAction/:Name/:Filter/:Param',
    loadChildren: () => import('./WorkflowDashBoard/WorkflowDashBoard.module').then(m => m.WorkflowDashBoardModule)
  },
  {
    path: 'Inbox/:menuId/:UserAction/:BPD/:BPI/:BPS/:Param',
    loadChildren: () => import('./WorkflowDashBoard/WorkflowDashBoard.module').then(m => m.WorkflowDashBoardModule)
  },

  //Workflow Inbox Lazy Loaded Module END





  //Route #10
  //Counterparty Management Lazy Loaded Module START
  {
    path: 'CounterpartyManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 1 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/counterparty-management.module').then(m => m.CounterpartyManagementModule)

  },

  //Counterparty Management Lazy Loaded Module END


  //Discounting Management Lazy Loaded Module START
  {
    path: 'DiscountingManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 579 },
    loadChildren: () => import('./discounting-management/discounting-management.module').then(m => m.DiscountingManagementModule)
  },
  //Discounting Management Lazy Loaded Module END


  //Route #11a,b,c
  //Add Counterparty Lazy Loaded Module START
  {
    path: 'AddCounterparty',
    loadChildren: () => import('./DashBoardManagement/addEntityInstance/addcounterparty.module').then(m => m.AddCounterpartyModule)
  },

  {
    path: 'AddLetterOfCredit',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 59 },
    loadChildren: () => import('./LetterOfCredit/LetterOfCredit.module').then(m => m.LetterOfCreditModule)
  },

  {
    path: 'AddCustomerGuarantee',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 11 },
    loadChildren: () => import('./Guarantee-Management/CustomerGuarantee.module').then(m => m.CustomerGuaranteeModule)
  },
  //Add Counterparty Lazy Loaded Module END




  //Route #12
  //CubeExplorer Lazy Loaded Module START
  {
    path: 'CubeExplorer/:menuId',
    loadChildren: () => import('./DashBoardManagement/cubexplorer/cubexplorer.module').then(m => m.CubeExplorerModule)
  },
  //CubeExplorer Lazy Loaded Module END






  //Route #13 a,b
  //Cash Management Lazy Loaded Module START
  {
    path: 'CashManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 19 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/CashManagement/Cash-Management.module').then(m => m.CashManagementModule)
  },

  {
    path: 'CashManagement/:cashId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 19 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/CashManagement/Cash-Management.module').then(m => m.CashManagementModule)
  },
  //Cash Management Lazy Loaded Module END

  //Rules Engine Audit Lazy Loaded Module END

  //Route #15a,b
  //Letter of Credit Lazy Loaded Module START
  {
    path: 'LetterOfCredit',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 59 },
    loadChildren: () => import('./LetterOfCredit/LetterOfCredit.module').then(m => m.LetterOfCreditModule)
  },


  {
    path: 'LetterOfCredit/:LetterOfCredit',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 59 },
    loadChildren: () => import('./LetterOfCredit/LetterOfCredit.module').then(m => m.LetterOfCreditModule)
  },
  //Letter of Credit Lazy Loaded Module END




  //Route #16a,b
  //Call Memo Lazy Loaded Module START
  {
    path: 'CallMemo',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 18 },
    loadChildren: () => import('./CallMemo/CallMemo.module').then(m => m.CallMemoModule)
  },

  {
    path: 'CallMemo/:CallMemo',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 18 },
    loadChildren: () => import('./CallMemo/CallMemo.module').then(m => m.CallMemoModule)
  },
  //Call Memo Lazy Loaded Module END





  //Route #17a,b
  //Credit Insurance Lazy Loaded Module START
  {
    path: 'CreditInsurance',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 289 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/CreditInsurance/CreditInsurance.module').then(m => m.CreditInsuranceModule)
  },


  {
    path: 'CreditInsurance/:CIReference',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 289 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/CreditInsurance/CreditInsurance.module').then(m => m.CreditInsuranceModule)
  },

  //Credit Insurance Lazy Loaded Module END





  //#Route 18a,b
  //Trading Counterparty Lazy Loaded Module START
  {
    path: 'TradingCounterparty',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 1 },
    loadChildren: () => import('./Trading-Counterparty/Trading-Counterparty.module').then(m => m.TradingCounterpartyModule)
  },



  {
    path: 'TradingCounterparty/:tradingcounterparty',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 1 },
    loadChildren: () => import('./Trading-Counterparty/Trading-Counterparty.module').then(m => m.TradingCounterpartyModule)
  },
  {
    path: 'CounterpartyLimits/:TradingCounterparty',//CRD-376-Pawan Prajapati
    component: CounterpartyLimitsComponent
  },
  //Trading Counterparty Lazy Loaded Module END






  //#Route 19a,b
  //Customer Guarantee Lazy Loaded Module START
  {
    path: 'CustomerGuarantee',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 11 },
    loadChildren: () => import('./Guarantee-Management/CustomerGuarantee.module').then(m => m.CustomerGuaranteeModule)
  },

  {
    path: 'CustomerGuarantee/:CustomerGuarantee',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 11 },
    loadChildren: () => import('./Guarantee-Management/CustomerGuarantee.module').then(m => m.CustomerGuaranteeModule)
  },
  //Customer Guarantee Lazy Loaded Module END





  //#Route 20a,b
  //Our Entity Management Lazy Loaded Module START
  {
    path: 'OurEntityManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 2 },
    loadChildren: () => import('./Our-Entity/Our-Entity.module').then(m => m.OurEntityModule)
  },

  {
    path: 'OurEntityManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 2 },
    loadChildren: () => import('./Our-Entity/Our-Entity.module').then(m => m.OurEntityModule)
  },
  {
    path: 'OurEntityManagement/:menuId/:tradingEntity',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 2 },
    loadChildren: () => import('./Our-Entity/Our-Entity.module').then(m => m.OurEntityModule)
  },
  //Our Entity Management Lazy Loaded Module END





  //#Route 21a,b
  //Data Search Lazy Loaded Module START
  {
    path: 'DataSearch',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 2 },
    loadChildren: () => import('./DataSearch/DataSearch.module').then(m => m.DataSearchModule)
  },

  {
    path: 'DataSearch/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 2 },
    loadChildren: () => import('./DataSearch/DataSearch.module').then(m => m.DataSearchModule)
  },
  //Data Search Lazy Loaded Module END



  //#Route 22a,b
  //Trade Netting Contract Lazy Loaded Module START
  {
    path: 'TradeNettingContract',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 37 },
    loadChildren: () => import('./NettingAgreement/NettingAgreement.module').then(m => m.TradeNettingContractModule)
  }
  ,
  {
    path: 'TradeNettingContract/:NettingAgreement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 37 },
    loadChildren: () => import('./NettingAgreement/NettingAgreement.module').then(m => m.TradeNettingContractModule)
  },

  //Trade Netting Contract Lazy Loaded Module END


  //#Route 23
  //Default path - loads Dashboard Component
  //For RiskCubed new HTML5 portal
  {
    path: '',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 247 },
    loadChildren: () => import('./DashBoardManagement/dashboard/dashboard.module').then(m => m.DashboardModule)
  },

  //#Route 24a,b
  //Credit Support Annex Lazy Loaded Module START
  {
    path: 'CreditSupportAnnex',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 25 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/CreditSupportAnnex/credit-support-annex.module').then(m => m.CreditSupportAnnexModule)
  }
  ,
  {
    path: 'CreditSupportAnnex/:Name',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 25 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/CreditSupportAnnex/credit-support-annex.module').then(m => m.CreditSupportAnnexModule)
  },
  //Credit Support Annex Lazy Loaded Module END

  //#Route 25a,b
  //Credit Facility Management Lazy Loaded Module START
  {
    path: 'CreditFacilityManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 268 },
    loadChildren: () => import('./CreditFacility/CreditFacility.module').then(m => m.CreditFacilityModule)
  },

  {
    path: 'CreditFacilityManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 268 },
    loadChildren: () => import('./CreditFacility/CreditFacility.module').then(m => m.CreditFacilityModule)
  },

  {
    path: 'CreditFacilityManagement/:menuId/:CreditFacility',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 268 },
    loadChildren: () => import('./CreditFacility/CreditFacility.module').then(m => m.CreditFacilityModule)
  },
  //Our Entity Management Lazy Loaded Module END

  //{
  //  path: 'Custom/:menuId',

  //  loadChildren: () => import('./CustomView/CustomView.module').then(m => m.CustomViewModule)
  //},

  //#Route 26a,b
  //Business Process Management Lazy Loaded Module START
  {
    path: 'Business Process Management',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 139 },
    loadChildren: () => import('./business-process-management/business-process-management.module').then(m => m.BusinessProcessManagementModule)
  },
  {
    path: 'Business Process Management/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 139 },
    loadChildren: () => import('./business-process-management/business-process-management.module').then(m => m.BusinessProcessManagementModule)
  },
  {
    path: 'Business Process Management/:menuId/:Name',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 139 },
    loadChildren: () => import('./business-process-management/business-process-management.module').then(m => m.BusinessProcessManagementModule)
  },
  //Business Process Management Lazy Loaded Module END
  //#Route 27
  //External Data Request Lazy Loaded Module START
  {
    path: 'ExternalDataRequest/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 343 },
    loadChildren: () => import('./ExternalDataRequest/ExternalDataRequest.module').then(m => m.ExternalDataRequestModule)
  },
  //External Data Request Lazy Loaded Module END
  //Route 28
  //Financial Spread Lazy Loaded Module START
  {
    path: 'FinancialSpreads',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 543 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/FAFinancialSpread/FAFinancialSpread.component.module').then(m => m.FAFinancialSpreadModule)
  },

  {
    path: 'FinancialSpreads/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 543 },
    loadChildren: () => import('./DashBoardManagement/counterparty-management/ChildComponents/FAFinancialSpread/FAFinancialSpread.component.module').then(m => m.FAFinancialSpreadModule)
  },
  //Financial Spread Lazy Loaded Module END

  //Exchange Margin Tool Lazy Load Module Start
  {
    path: 'ExchangePortfolioManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 533 },
    loadChildren: () => import('./ExchangePortfolio/ExchangePortfolio.module').then(m => m.ExchangePortfolioModule)
  },

  {
    path: 'ExchangePortfolioManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 533 },
    loadChildren: () => import('./ExchangePortfolio/ExchangePortfolio.module').then(m => m.ExchangePortfolioModule)
  },

  {
    path: 'ExchangeScenarioManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 532 },
    loadChildren: () => import('./ExchangeScenario/ExchangeScenario.module').then(m => m.ExchangeScenarioModule)
  },

  {
    path: 'ExchangeScenarioManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 532 },
    loadChildren: () => import('./ExchangeScenario/ExchangeScenario.module').then(m => m.ExchangeScenarioModule)
  },
  {
    path: 'ExchangeReportManagement',
    loadChildren: () => import('./ExchangeMarginReport/ExchangeMarginReport.module').then(m => m.ExchangeMarginReportModule)
  },

  {
    path: 'ExchangeReportManagement/:menuId',
    loadChildren: () => import('./ExchangeMarginReport/ExchangeMarginReport.module').then(m => m.ExchangeMarginReportModule)
  },
  //Exchange Margin Tool Lazy Load Module End

  //#Route 30
  //Business Process Type Lazy Loaded Module START
  {
    path: 'BusinessProcessType',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 222 },
    loadChildren: () => import('./business-process-type/business-process-type.module').then(m => m.BusinessProcessTypeModule)
  },
  {
    path: 'BusinessProcessType/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 222 },
    loadChildren: () => import('./business-process-type/business-process-type.module').then(m => m.BusinessProcessTypeModule)
  },
  {
    path: 'BusinessProcessType/:menuId/:Name',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 222 },
    loadChildren: () => import('./business-process-type/business-process-type.module').then(m => m.BusinessProcessTypeModule)
  },
  //Business Process Type Lazy Loaded Module END

  //#Route 32
  //ScoreCard Lazy Loaded Module START
  {
    path: 'Scorecard/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 157 },
    loadChildren: () => import('./ScoreCard/ScoreCard.module').then(m => m.ScoreCardModule)
  },
  //ScoreCard Lazy Loaded Module END
  //#Route 33
  //ScoringModel Lazy Loaded Module START
  {
    path: 'ScoringModel/:Name',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 166 },
    loadChildren: () => import('./ScoringModel/ScoringModel.module').then(m => m.ScoringModelModule)
  },
  {
    path: 'ScoringModel',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 166 },
    loadChildren: () => import('./ScoringModel/ScoringModel.module').then(m => m.ScoringModelModule)
  },
  {
    path: 'ScoringModelSummary/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 166 },
    loadChildren: () => import('./ScoringModelSummary/ScoringModelSummary.module').then(m => m.ScoringModelSummaryModule)
  },
  //ScoringModel Lazy Loaded Module END

  //#Route 32a,b
  //Netting Contract Clause Lazy Loaded Module START
  {
    path: 'NettingContractClause',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 93 },
    loadChildren: () => import('./NettingContractClause/NettingContractClause.module').then(m => m.NettingContractClauseModule)
  }
  ,
  {
    path: 'NettingContractClause/:ContractClause',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 93 },
    loadChildren: () => import('./NettingContractClause/NettingContractClause.module').then(m => m.NettingContractClauseModule)
  },

  // Static Admin
  {
    path: 'StaticAdmin/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 2 },
    loadChildren: () => import('./StaticAdmin/StaticAdmin.module').then(m => m.StaticAdminModule)
  },
  //#Route 33a,b
  //User management Lazy Loaded Module START
  {
    path: 'UserManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 13 },
    loadChildren: () => import('./UserManagement/UserManagement.module').then(m => m.UserManagementModule)
  }
  ,
  {
    path: 'UserManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 13 },
    loadChildren: () => import('./UserManagement/UserManagement.module').then(m => m.UserManagementModule)
  },
  {
    path: 'UserManagement/:menuId/:UserName',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 13 },
    loadChildren: () => import('./UserManagement/UserManagement.module').then(m => m.UserManagementModule)
  },
  {
    path: 'User RoleManagement',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 14 },
    loadChildren: () => import('./UserRoleManagement/UserRoleManagement.module').then(m => m.UserRoleManagementModule)
  }
  ,
  {
    path: 'User RoleManagement/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 14 },
    loadChildren: () => import('./UserRoleManagement/UserRoleManagement.module').then(m => m.UserRoleManagementModule)
  },
  {
    path: 'User RoleManagement/:menuId/:UserRole',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 14 },
    loadChildren: () => import('./UserRoleManagement/UserRoleManagement.module').then(m => m.UserRoleManagementModule)
  },


  //#Route 43a
  //Test Control states Lazy Loaded Module START
  {
    path: 'StressScenarioTesting/:menuId',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 273 },
    loadChildren: () => import('./StressTesting/StressTesting.module').then(m => m.StressTestingModule)
  },
  {
    path: 'ScenarioDetail',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 273 },
    loadChildren: () => import('./StressTesting/ScenarioDetail/ScenarioDetail.module').then(m => m.ScenarioDetailModule)
  },
  {
    path: 'ScenarioDetail/:StressScenarioID',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 273 },
    loadChildren: () => import('./StressTesting/ScenarioDetail/ScenarioDetail.module').then(m => m.ScenarioDetailModule)
  },
  {
    path: 'ScenarioDetail/:StressScenarioID/:Action',
    // canMatch: [PermissionGuard],
    // data: { lDataEntityId: 273 },
    loadChildren: () => import('./StressTesting/ScenarioDetail/ScenarioDetail.module').then(m => m.ScenarioDetailModule)
  },

  //Collateral Tracker Lazy Loaded Module START
  {
    path: 'CollateralTracker/:CollateralTracker',
    loadChildren: () => import('./LCTracker/CollateralTracker.module').then(m => m.CollateralTrackerModule)
  },
  {
    path: 'CollateralTracker/:CollateralTracker',
    loadChildren: () => import('./LCTracker/CollateralTracker.module').then(m => m.CollateralTrackerModule)
  }
];









@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { enableTracing: true, useHash: true, onSameUrlNavigation: 'reload' } // <-- debugging purposes only
    )
  ],
  exports:
    [
      RouterModule, RouterOutlet
    ],
  providers: [DataService]
})
export class AppRoutingModule {


}



